import { AfterViewInit, ChangeDetectorRef, Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { HelperService } from '../../Services/helper.service';
import { TranslationService } from "../../Services/translation.service";
import { LocalStorageService } from "../../Services/local-storage.service";
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { fromEvent, Observable, Subscription } from 'rxjs';
import { debounceTime, filter, map } from 'rxjs/operators';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { CITY } from 'src/app/tokens';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})

export class NavbarComponent implements OnInit, AfterViewInit {
  language: string = '';
  word: any = {};
  currentCity: string;
  public openMobile: boolean;
  public displayMobile: boolean;
  public mobileWidth = 991;
  resizeObservable$: Observable<Event>;
  url$: Observable<string> = new Observable<string>();
  resizeSubscription$: Subscription;
  prevScrollPos: number;
  reloadCategories: boolean = true;
  searchForm = new UntypedFormGroup({
    searchText: new UntypedFormControl(''),
  });
  isGraphite: boolean = false;
  bookyCities: string[] = ['skopje', 'beograd'];
  isOutside: boolean = false;
  hasLoaded: boolean = false;

  constructor(
    private changeDetector: ChangeDetectorRef,
    public router: Router,
    private activeRoute: ActivatedRoute,
    public translationService: TranslationService,
    private localStorage: LocalStorageService,
    private helperService: HelperService,
    @Inject(PLATFORM_ID) private platformId: Object,
    @Inject(DOCUMENT) private document: Document,
    @Inject(CITY) private injectedCity: string
  ) {
    this.word = this.translationService.word;
    this.language = this.translationService.language;
    this.url$ = this.router.events.pipe(
      filter((event: any) => event instanceof NavigationEnd),
      map((event: NavigationEnd) => event.url)
    );


  }

  ngAfterViewInit(): void {
    // this.helperService.markSelectedCity();
  }

  ngOnInit(): void {
    this.url$.subscribe({
      next: (val) => {
        if(val.includes('3054')){
          this.isGraphite = true;
          // console.log(val.includes('3054'));
          // console.log('%c ' + this.isGraphite, 'font-size: 24px')
        }
        else
          this.isGraphite = false;
      }
    })
    if(!isPlatformBrowser(this.platformId))
      return;
    this.document.defaultView.addEventListener('scroll', this.hideBar, true);
    this.currentCity = this.helperService.getCity();
    this.prevScrollPos = this.document.defaultView.pageYOffset;

    //for browser only. should make it more friendly in the future
    if(window.location.host === 'booky.mk'){
      this.isOutside = true;
      this.currentCity = 'skopje';
    }
    if(window.location.host === 'booknow.rs'){
      this.isOutside = true;
      this.currentCity = 'beograd';
    }
    this.hasLoaded = true;

    if (this.document.defaultView.innerWidth < this.mobileWidth) {
      this.displayMobile = true;
    }
    else {
      this.displayMobile = false;
    }

    this.resizeObservable$ = fromEvent(this.document.defaultView, 'resize');
    this.resizeSubscription$ = this.resizeObservable$.pipe(debounceTime(500)).subscribe(evt => {
      if (this.document.defaultView.innerWidth < this.mobileWidth) {
        this.displayMobile = true;
      }
      else {
        this.displayMobile = false;
      }
    })
  }

  onSubmit() {
    if (this.searchForm.value.searchText.length >= 3) {
      this.router.navigate(["search", this.searchForm.value.searchText]);
    }

    this.searchForm.reset();
  }

  ngOnDestroy() {
    if(!isPlatformBrowser(this.platformId))
      return;
    this.resizeSubscription$.unsubscribe()
    this.document.defaultView.removeEventListener('scroll', this.hideBar, true);
  }

  changeLanguage(): void {
    // return null;
    const language = this.document.getElementById("language-text").innerHTML;
    // const getLang = this.translationService.getCurrentLanguage();

    let toggleTo = 'bg'; // default

    const city = this.helperService.getCity();

    if (city == 'skopje') {
      toggleTo = 'mk';
    } else if (city == 'beograd') {
      toggleTo = 'sr';
    }

    let url = new URL(location.href);
    url.pathname = url.pathname.replace("/en", "");

    if (language == "EN") {
      this.document.getElementById('language-text').innerHTML = this.translationService.getCurrentLanguage().code.toUpperCase();
      this.localStorage.setItem('language', 'en');
      this.translationService.language = 'en';

      url.pathname = '/en' + url.pathname;
      this.router.navigate([url.pathname]);

      this.translationService.setLang(true);
    }
    else {
      this.document.getElementById("language-text").innerHTML = "EN";
      this.localStorage.setItem('language', toggleTo);
      this.translationService.language = toggleTo;
      let newUrl = url.pathname.replace('/en', "");
      url.pathname = newUrl;
      this.router.navigate([newUrl]);

      this.translationService.setLang(false);
    }

    this.word = this.translationService.word;
    this.language = this.translationService.language;

    this.reloadCategories = false;
    this.changeDetector.detectChanges();
    this.reloadCategories = true;
    this.changeDetector.detectChanges();
  }

  getHost(): string {
    return this.helperService.getHost();
  }

  citiesDropDown() {
    this.document.getElementById('citiesDropDown').classList.toggle('active');
  }
  toggleSearch() {
    this.document.getElementById('search').classList.toggle('active-mobile');
  }

  showMobileMenu() {
    this.document.body.style.overflowY = "hidden";
    this.document.getElementById('mobile-menu').style.display = "block";
  }

  hideBar(): void {
    // let currentScrollPos = window.pageYOffset;

    // if (this.prevScrollPos > currentScrollPos) {
    //   document.getElementById("category-nav").style.top = "60px";
    // } else if(this.prevScrollPos <= currentScrollPos){
    //   document.getElementById("category-nav").style.top = "0px";
    // }
    // this.prevScrollPos = currentScrollPos;
    // (() => {
    // }, 250)
  }
}
